import { fromHttpPromise, type RpcError } from 'pulse/adapters';
import userInfo from 'hub-http/userInfo';
import { Resolver, ResolverHttpClient } from 'pulse/resolvers';
import type { SearchCrmObjectsErrorType } from '../../../__generated__/chirp/com/hubspot/sales/rpc/ViewServiceRpc';
import { makeCrmSearchRequest, makeCrmSearchAllPropertiesRequest } from './api';
import { extractUserId } from './getUserId';
import {
  CrmObject,
  CrmSearchAllPropertiesArgs,
  CrmSearchResults,
} from './types';

export const defaultCrmSearchResolver = fromHttpPromise(
  'defaultCrmSearchResolver',
  makeCrmSearchRequest
);

export const defaultCrmSearchAllPropertiesResolver = fromHttpPromise(
  'defaultCrmSearchAllPropertiesResolver',
  (http: ResolverHttpClient, args: CrmSearchAllPropertiesArgs) =>
    makeCrmSearchAllPropertiesRequest(http, args, () =>
      userInfo({ ignoreRedirect: true }).then(extractUserId)
    )
) as Resolver<
  CrmSearchAllPropertiesArgs,
  CrmSearchResults<CrmObject>,
  Error | RpcError<SearchCrmObjectsErrorType>
>;
